<template>
  <div>
    <a-drawer
      width="600"
      :title="drawerTitle"
      placement="right"
      :closable="false"
      v-model:visible="createVisible"
      @close="closeCreateDrawer"
    >
      <a-form
        ref="createFormRef"
        :rules="createFormRules"
        :model="createForm"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-item label="设备名称" name="name">
          <a-input :maxlength="100" v-model:value="createForm.name" />
        </a-form-item>
        <a-form-item label="Distinct_id" name="distinctId">
          <a-input :maxlength="100" v-model:value="createForm.distinctId" />
        </a-form-item>
      </a-form>
      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1
        }"
      >
        <a-button style="margin-right: 8px" @click="closeCreateDrawer"
          >取消</a-button
        >
        <a-button type="primary" @click="saveCreateDrawer">保存</a-button>
      </div>
    </a-drawer>
  </div>
</template>
<script>
import { defineComponent, reactive, toRefs, inject } from 'vue'
export default defineComponent({
  setup() {
    const initData = inject('initState')
    const state = reactive({
      labelCol: {
        span: 4
      },
      wrapperCol: {
        span: 14
      }
    })
    return {
      ...toRefs(initData),
      ...toRefs(state)
    }
  }
})
</script>
<style>
.self-process .ant-progress-inner {
  height: 40px;
  border-radius: 0px !important;
}
.self-process .ant-progress-inner .ant-progress-bg {
  height: 40px !important;
  border-radius: 0px !important;
}
</style>
